/* Exact-package adapter for the installed Shrine form. Native transport/drawer retained. */
(() => {
  const initialize = async () => {
    for (const root of document.querySelectorAll('.nfs-buy:not([data-ready])')) {
      const section = root.dataset.section;
      const pf = document.querySelector(`product-form[data-section="${section}"].main-product-form`);
      if (!pf?.form || !pf.variantInputs) continue;
      root.dataset.ready = 'true';
      const config = JSON.parse(root.querySelector('[data-nfs-config]').textContent);
      const sectionRoot = document.getElementById(`shopify-section-${section}`);
      const picker = sectionRoot.querySelector('variant-selects');
      const buttons = [...root.querySelectorAll('[data-projectors]')];
      const choices = root.querySelector('[data-design-choices]');
      const toggles = [...root.querySelectorAll('[data-service]')];
      const nativeItems = root.querySelector('.nfs-native-items');
      const designStep = root.querySelector('[data-nfs-designs]');
      let designsConfirmed = false;
      const format = amount => new Intl.NumberFormat(config.locale,{style:'currency',currency:config.currency}).format(amount/100);
      const packCount = variant => Number(variant?.option1?.split(' ')[0]);
      let count = packCount(config.packages.find(v=>String(v.id)===String(pf.formIdInput.value))) || 1;
      const designs = Array(4).fill(config.designs[0]);
      let cartItems = [], cartVerified = false, cartChecking = true, addedServices = [], submittedServices = [], cartRequest = 0;
      const draw = () => {
        choices.replaceChildren();
        for(let i=0;i<count;i++) {
          const row=document.createElement('label'); row.className='nfs-design-choice';
          const label=document.createElement('span');label.textContent=`Projector ${i+1}`;
          const select=document.createElement('select');select.setAttribute('aria-label',`Projector ${i+1} design`);
          config.designs.forEach(name=>{const option=document.createElement('option');option.value=name;option.textContent=name;option.selected=designs[i]===name;select.append(option);});
          const icon=document.createElement('img');icon.className='nfs-design-icon';icon.width=44;icon.height=44;icon.alt='';icon.src=config.icons[designs[i]];const field=document.createElement('span');field.className='nfs-design-field';field.append(icon,select);select.addEventListener('change',()=>{designs[i]=select.value;icon.src=config.icons[select.value];sync();});row.append(label,field);choices.append(row);
        }
      };
      const sync = () => {
        const variant=config.packages.find(v=>packCount(v)===count);
        let valid=cartVerified && !!variant?.available && designs.slice(0,count).every(d=>config.designs.includes(d));
        let total=variant?.price || 0; const selected=[];addedServices=[];
        toggles.forEach(toggle=>{
          const extra=config.services[toggle.dataset.service];
          const already=!!extra && cartItems.some(item=>String(item.variant_id)===String(extra.id));
          root.querySelector(`[data-already="${toggle.dataset.service}"]`).hidden=!already;
          if(toggle.checked && !already) {
            valid &&= !!extra?.available;
            if(extra){selected.push(extra);total+=extra.price;addedServices.push(extra.id);}
          }
        });
        nativeItems.replaceChildren();
        const main=document.createElement('span');main.className=`nfs-package-item main-offer-item-${section}`;main.dataset.id=variant?.id || '';nativeItems.append(main);
        selected.forEach(extra=>{const node=document.createElement('span');node.className=`product-info-upsell-${section}`;node.dataset.id=extra.id;node.dataset.selected='true';nativeItems.append(node);});
        pf.mainBundleItems=nativeItems.querySelectorAll('.nfs-package-item');
        pf.customFields=Array.from({length:count},(_,i)=>({dataset:{disabled:'false'},fieldName:`Projector ${i+1} design`,prevValue:designs[i]}));
        pf.customFields.push({dataset:{disabled:'false'},fieldName:'Projectors in package',prevValue:String(count)});
        pf.formIdInput.value=variant?.id || '';
        const quantity=pf.form.querySelector('[name="quantity"]');if(quantity)quantity.value=1;
        buttons.forEach(button=>{const active=Number(button.dataset.projectors)===count;button.classList.toggle('is-selected',active);button.setAttribute('aria-pressed',String(active));});
        sectionRoot.querySelectorAll('[data-nfs-total]').forEach(el=>{el.textContent=`${format(total)} ${config.currency}`;});
        // While the cart check is in flight the button stays locked, but no error is shown.
        root.querySelector('.nfs-buy-error').hidden=valid || cartChecking;
        root.dataset.valid=String(valid);root.dataset.total=String(total);root.dataset.projectors=String(count);
        sectionRoot.querySelectorAll('[id^="sticky-atc-price-"], [id^="sticky-atc-separate-price-"], .main-atc-price').forEach(el=>{el.textContent=`${format(total)} ${config.currency}`;});
        // Only release our own initialization lock, never native pending/sold-out locks.
        sectionRoot.querySelectorAll('[data-nfs-readiness-lock]').forEach(el=>{
          if(valid && el.getAttribute('aria-disabled')!=='true' && el.dataset.unavailable!=='true'){el.removeAttribute('disabled');el.removeAttribute('data-nfs-readiness-lock');}
        });
      };
      // Confirmed in destination main.js: scalar deletion is conditional on quantity-breaks.
      pf.form.addEventListener('formdata',event=>{
        if(event.formData.has('items[0][id]')){event.formData.delete('id');event.formData.delete('quantity');}
      });
      // Sticky invokes this method directly, rather than submitting the form. Gate both entrances.
      const nativeSubmit=pf.handleSubmit;
      const prepareSubmit=event=>{
        if(root.dataset.valid!=='true' || pf.submitButton.dataset.unavailable==='true' || pf.submitButton.getAttribute('aria-disabled')==='true' || pf.submitButton.hasAttribute('disabled')){
          event?.preventDefault();if(!cartChecking)root.querySelector('.nfs-buy-error').hidden=false;return false;
        }
        // Designs are chosen in a second step: the first Add to Cart only opens it.
        if(!designsConfirmed){event?.preventDefault();if(!designStep.open)designStep.showModal();return false;}
        // Capture only accepted attempts: sync may change the checkboxes while native fetch is pending.
        submittedServices=addedServices.slice();return true;
      };
      pf.handleSubmit=function(event){
        if(!prepareSubmit(event))return;
        return nativeSubmit.call(this,event);
      };
      pf.form.addEventListener('submit',event=>{
        if(!prepareSubmit(event))event.stopImmediatePropagation();
      },true);
      const setCount=n=>{if(![1,2,4].includes(n))return;count=n;draw();sync();};
      buttons.forEach(button=>button.addEventListener('click',()=>{
        const n=Number(button.dataset.projectors);setCount(n);
        const select=picker?.querySelector('select');const variant=config.packages.find(v=>packCount(v)===n);
        if(select && variant && select.value!==variant.option1){select.value=variant.option1;select.dispatchEvent(new Event('change',{bubbles:true}));}
      }));
      picker?.addEventListener('change',()=>{if(picker.currentVariant)setCount(packCount(picker.currentVariant));});
      toggles.forEach(toggle=>toggle.addEventListener('change',sync));
      designStep.querySelector('[data-nfs-close]').addEventListener('click',()=>designStep.close());
      designStep.addEventListener('click',event=>{
        if(event.target!==designStep)return;
        // The dialog's own padding also targets the dialog element; close only for clicks outside its box.
        const box=designStep.getBoundingClientRect();
        if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)designStep.close();
      });
      designStep.querySelector('[data-nfs-confirm]').addEventListener('click',()=>{
        designsConfirmed=true;
        try{pf.submitButton.click();}finally{designsConfirmed=false;}
        if(root.dataset.valid==='true')designStep.close();
      });
      const refreshCart=async()=>{
        const request=++cartRequest;
        cartVerified=false;cartChecking=true;sync();
        try {
          const base=window.Shopify?.routes?.root || '/';
          if(!/^\/(?!\/)[\w/-]*$/.test(base))throw Error('Invalid locale route');
          const response=await fetch(`${base.replace(/\/+$/,'')}/cart.js`,{headers:{Accept:'application/json'},cache:'no-store'});
          if(!response.ok)throw Error('Cart could not be verified');
          const cart=await response.json();
          if(request!==cartRequest)return;
          cartItems=cart.items;cartVerified=true;cartChecking=false;
        } catch(error){
          if(request!==cartRequest)return;
          cartVerified=false;cartChecking=false;console.warn('NFSprojectors cart reconciliation unavailable',error);
        }
        sync();
      };
      if(typeof subscribe==='function') {
        subscribe(PUB_SUB_EVENTS.cartUpdate,event=>{
          if(event?.source==='product-form'){
            submittedServices.forEach(id=>{if(!cartItems.some(i=>String(i.variant_id)===String(id)))cartItems.push({variant_id:id});});
            submittedServices=[];
          }
          refreshCart();
        });
        subscribe(PUB_SUB_EVENTS.variantChange,event=>{if(event?.data?.sectionId===section){setCount(packCount(event.data.variant));}});
      }
      window.addEventListener('pageshow',refreshCart);
      draw();sync();await refreshCart();root.dataset.nativeReady='true';
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
